<template>
  <modal-wrapper popup-name="order-status" @closePopup="resetPopup(), deleteStorageData()">
    <template v-slot:title>
      <h2 class="popup__title">
        Статус заказа
      </h2>
    </template>
    <template v-slot:content="scope">
      <template v-if="checkStep !== 3">
        <div class="universal-popup">
          <div class="universal-popup__inputs">
            <div class="universal-popup__section">
              <label class="form__input-container">
                <span class="form__input-label">Номер заказа / e-mail</span>
                <input
                  ref="numOrEmailElem"
                  v-model="form.orderNumOrEmail"
                  type="text"
                  :class="['form__input-input', {_error: numOrEmailError.isShow}]"
                  placeholder="Введите e-mail или номер заказа"
                  @keyup.enter="sendFirstResponse"
                  @focus="() => numOrEmailError.isShow = false"
                >
                <span class="form__input-error">{{ numOrEmailError.text }}</span>
              </label>
            </div>
          </div>

          <div v-if="checkStep === 2" class="universal-popup__inputs">
            <div class="universal-popup__section">
              <label class="form__input-container">
                <span class="form__input-label">Письмо с кодом подтверждения отправлено на {{ hiddenEmail }}</span>
                <input
                  v-model="form.confirmCode"
                  type="text"
                  :class="['form__input-input', {_error: confirmInputError.isShow}]"
                  placeholder="Введите код"
                  @keyup.enter="secondStepClickHandler"
                >
                <span class="form__input-error"> {{ confirmInputError.text }}</span>
              </label>
            </div>
            <label class="form__checkbox-container">
              <input
                v-model="form.willAuth"
                type="checkbox"
                data-required="checkbox"
                @click="scope.changeReloadStatus"
              >
              <span class="form__checkbox-body" />
              <span :class="['form__checkbox-agree', {checked: form.willAuth}]">
                Авторизоваться
              </span>
            </label>
          </div>

          <div class="universal-popup__buttons">
            <vue-recaptcha
              v-if="recaptchaToken && !isCaptchaDisabled && checkStep === 1"
              ref="recaptcha"
              class="recaptcha"
              size="invisible"
              :sitekey="recaptchaToken"
              @verify="(resp) => onRecaptchaVerified(resp)"
            />
            <button
              v-if="checkStep === 1"
              class="_btn submit-button"
              @click="sendFirstResponse"
            >
              <span />
              <p>Узнать статус</p>
            </button>
            <button
              v-if="checkStep === 2"
              class="_btn submit-button"
              @click="secondStepClickHandler"
            >
              <span />
              <p>Далее</p>
            </button>
            <p v-if="showEmptyOrderListWarning" class="_error">
              Нет активных заказов
            </p>
          </div>
        </div>
      </template>
      <template v-else>
        <orderBlock
          v-for="(item, index) of ordersList"
          :key="`order-numer-${index + 1}`"
          class="order-item"
          :order-title="item.number"
          :order-date="item.dateCreated"
          :order-status="item.status"
          :send-status="item.sendStatus"
          @sendOnMail="sendMailHandler"
        />
      </template>
    </template>
  </modal-wrapper>
</template>

<script>
import { VueRecaptcha } from 'vue-recaptcha';
import ModalWrapper from '@/modals/modalWrapper.vue';
import orderBlock from '../../components/orderBlock.vue';
import api from './services/api';

export default {
  name: 'order-status-modal',

  components: {
    ModalWrapper,
    orderBlock,
    VueRecaptcha,
  },

  data() {
    return {
      checkStep: 1,
      form: {
        orderNumOrEmail: '',
        confirmCode: '',
        willAuth: false,
      },
      numOrEmailError: {
        isShow: false,
        text: 'Введите номер заказа или e-mail',
      },
      confirmInputError: {
        isShow: false,
        text: 'Поле не заполнено',
      },
      firstField: '',
      requestType: '',
      token: '',
      ordersList: [],
      tokenTimer: null,
      hiddenEmail: '',
      recaptchaToken: '',
      recaptchaResponse: '',
      isCaptchaDisabled: false,
      showEmptyOrderListWarning: false,
    };
  },

  mounted() {
    this.recaptchaToken = process.env.RECAPTCHA_TOKEN;
    this.isCaptchaDisabled = process.env.RECAPTCHA_NO_CHECK || false;

    let userOrders = window.localStorage.getItem('userOrders');
    const currDate = new Date();
    if (userOrders) {
      userOrders = JSON.parse(userOrders);

      const createDate = new Date(userOrders.createDate);
      const timeDifferenceInMin = Math.floor((currDate - createDate) / (1000 * 60));
      if (timeDifferenceInMin < 9) {
        this.ordersList = userOrders.orders;
        this.checkStep = 3;

        return;
      }
      window.localStorage.removeItem('userOrders');
    }
    let token = window.localStorage.getItem('getOrdersListToken');

    if (token) {
      token = JSON.parse(token);

      const createDate = new Date(token.createDate);
      const timeDifferenceInMin = Math.floor((currDate - createDate) / (1000 * 60));
      if (timeDifferenceInMin < 59) {
        this.token = token.token;

        this.firstField = token.email;
        this.form.orderNumOrEmail = token.email;
        this.hiddenEmail = token.email;
        this.requestType = 'email';

        this.checkStep = 2;

        return;
      }
      window.localStorage.removeItem('getOrdersListToken');
    }
  },

  methods: {
    onRecaptchaVerified(resp) {
      this.recaptchaResponse = resp;

      this.firstStepClickHandler();
    },
    getRightOrderList(orders) {
      if (!Array.isArray(orders)) return [orders];

      return orders.filter((order) => order.status !== 'Выполнен' && order.status !== 'Отменён');
    },
    deleteStorageData() {
      window.localStorage.removeItem('getOrdersListToken');
      window.localStorage.removeItem('userOrders');
    },
    resetPopup() {
      this.checkStep = 1;
      this.form.orderNumOrEmail = '';
      this.form.confirmCode = '';
      this.form.willAuth = false;

      this.numOrEmailError.isShow = false;
      this.numOrEmailError.text = 'Введите номер заказа или e-mail';

      this.confirmInputError.isShow = false;
      this.confirmInputError.text = 'Поле не заполнено';

      this.firstField = '';
      this.requestType = '';
      this.token = '';
      this.ordersList = [];
      this.hiddenEmail = '';
    },

    firstStepValidate(value) {
      if (value) {
        const emailRegExp = /^.+@.+\..+$/;

        const isValid = emailRegExp.test(value);
        if (isValid) {
          this.requestType = 'email';
          this.firstField = value;

          return true;
        }

        const isOrderNumber = !Number.isNaN(+value);
        if (!isOrderNumber) {
          this.numOrEmailError.isShow = true;
          return null;
        }

        this.requestType = 'orderNum';
        this.firstField = value;

        return true;
      }

      this.numOrEmailError.isShow = true;
      return false;
    },

    secondStepValidate(value) {
      if (value) {
        const codeRegExp = /^[a-zA-Z0-9]{6}$/;

        const isValid = codeRegExp.test(value);

        if (isValid) return true;

        return false;
      }
      return false;
    },

    async sendFirstResponse() {
      if (!this.isCaptchaDisabled && this.recaptchaToken) {
        await this.$refs.recaptcha.execute(this.recaptchaToken);
      } else {
        this.firstStepClickHandler();
      }
    },

    async firstStepClickHandler() {
      if (this.checkStep === 1) {
        const isValid = this.firstStepValidate(this.form.orderNumOrEmail);

        if (isValid) {
          const formData = new FormData();
          let response;

          if (!this.isCaptchaDisabled && this.recaptchaResponse) {
            formData.append('g-recaptcha-response', this.recaptchaResponse);
          }

          if (this.requestType === 'email') {
            formData.append('email', this.firstField);
            response = await api.sendConfirmCodeByEmail(formData);
          } else if (this.requestType === 'orderNum') {
            formData.append('orderNumber', this.firstField);
            response = await api.sendConfirmCodeByOrderNumber(formData);
          }

          const { data } = response;

          if (data?.error) {
            this.numOrEmailError.text = data.error;
            this.numOrEmailError.isShow = true;
          } else {
            const tokenObj = {
              token: data.token,
              email: data.email,
              createDate: new Date(),
            };
            window.localStorage.setItem('getOrdersListToken', JSON.stringify(tokenObj));

            this.token = data.token;
            this.hiddenEmail = data.email;
            this.checkStep = 2;

            if (!this.isCaptchaDisabled) {
              this.$refs.recaptcha.reset();
              this.recaptchaResponse = '';
            }

            setTimeout(() => {
              this.resetPopup();
            }, (1000 * 60 * 60));
          }
        }
      }
    },

    async secondStepClickHandler() {
      if (this.checkStep === 2) {
        const formData = new FormData();

        formData.append('code', this.form.confirmCode);
        if (this.token) {
          formData.append('token', this.token);
        }
        if (this.form.willAuth) {
          formData.append('authorize', 'Y');
        } else {
          formData.append('authorize', 'N');
        }

        let response;
        if (this.requestType === 'email') {
          formData.append('email', this.firstField);

          response = await api.checkConfirmCodeByEmail(formData);
        } else if (this.requestType === 'orderNum') {
          formData.append('orderNumber', this.firstField);

          response = await api.checkConfirmCodeByOrderNumber(formData);
        }
        const { data } = response;

        if (data?.error) {
          this.confirmInputError.text = data.error;
          this.confirmInputError.isShow = true;
        } else if (this.getRightOrderList(data.orders).length) {
          const userOrders = {
            orders: this.getRightOrderList(data.orders),
            createDate: new Date(),
          };
          window.localStorage.setItem('userOrders', JSON.stringify(userOrders));

          this.ordersList = userOrders.orders;
          this.checkStep = 3;

          if (!this.isCaptchaDisabled) {
            this.$refs.recaptcha.reset();
            this.recaptchaResponse = '';
          }

          setTimeout(() => {
            this.resetPopup();
          }, (1000 * 60 * 10));
        } else {
          this.showEmptyOrderListWarning = true;
          setTimeout(() => {
            this.showEmptyOrderListWarning = false;
          }, 2000);
        }
      }
    },

    async sendMailHandler(data) {
      if (data) {
        const formData = new FormData();
        formData.append('orderNumber', data.orderNumber);

        await api.sendStatusOrderByOrderNumber(formData)
          .then((res) => {
            if (!res.data.error) {
              this.ordersList = this.ordersList.map((order) => {
                if (order.number === data.orderNumber) {
                  order.sendStatus = {
                    isShow: true,
                    isSuccess: true,
                    text: 'Информация о статусе заказа направлена на e-mail',
                  };
                }
                return order;
              });
            } else {
              this.ordersList = this.ordersList.map((order) => {
                if (order.number === data.orderNumber) {
                  order.sendStatus = {
                    isShow: true,
                    isSuccess: false,
                    text: res.data.error,
                  };
                }
                return order;
              });
            }
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.universal-popup__buttons {
  margin: 30px 0 0 0;

  & .recaptcha {
    margin-bottom: 20px;
  }
}

.form__checkbox-agree {
  font-size: 18px;
  line-height: 22px;
  letter-spacing: 3%;
  color: #858584;

  &.checked {
    color: #474747
  }
}

.form__input-label {
  white-space: normal;
}

.order-item + .order-item {
  &::before {
    content: '';
    display: block;
    width: 100%;
    height: 1px;
    margin: 15px 0 15px 0;
    background-color: #C5C5C5;
  }
}

._error {
  margin-top: 20px;
  color: red;
}

.recaptcha {
  visibility: hidden;
}
</style>
